export default "__VITE_ASSET__C2Hfxd3T__"